module.exports = __webpack_public_path__ + "media/packs/images/flags/ER-523934d0677094bc4e91de01ce8a9fec.png";